
import { mapState, mapActions } from 'vuex';
import DropdownMenuWidth from '@/enums/DropdownMenuWidth';

export default {
  name: 'AppComment',
  props: {
    comment: {
      type: Object,
      default: () => {}
    },
    showSpamReportButton: { type: Boolean, default: true }
  },
  data() {
    return {
      editOrDeleteOptions: [
        {
          name: this.$t('edit_comment_label'),
          value: 'edit'
        },
        {
          name: this.$t('delete_comment_label'),
          value: 'delete',
          danger: true
        }
      ],
      isEditing: false
    };
  },
  computed: {
    ...mapState('comment', ['isLoadingComments']),
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapState('window', ['windowService']),
    DropdownMenuWidth: () => DropdownMenuWidth
  },
  methods: {
    ...mapActions('comment', ['deleteComment']),
    onClickEditOrDelete(value) {
      if (value === 'delete') {
        this.windowService
          .confirm(this.$t('delete_comment_confirmation'))
          .then(response => {
            if (response) {
              this.deleteComment({
                reviewId: this.comment.review_id,
                commentId: this.comment.id
              });
            }
          });
      } else {
        this.isEditing = true;
      }
    }
  }
};
